import React from 'react';
import {
  Route, Switch, Redirect, Router as HashRouter,
} from 'react-router-dom';
import { Alert, Layout } from 'antd';
import { PropTypes } from 'prop-types';
import { LoginPage, SsoPage } from './modules/auth/pages';
import MainPage from './modules/app/pages/main.page';
import TokenNoValido from './modules/app/pages/TokenNoValido.page';
import { Box } from './modules/shared/components/basic';
import EncargosMostrar from './modules/encargos/pages/encargos.mostrar.page';
import MessageReceiver from './modules/app/components/messageReceiver';
import { ShowIf } from './modules/shared/components';
import SystemMessenger from './modules/app/components/SystemMessenger';
import GIOTalkPage from './modules/giotalk/pages/giotalk.page';
import NotificacionesGIOTalk from './modules/giotalk/pages/giotalk.notificaciones.page';
import GIOTalkOpcionesPage from './modules/giotalk/pages/giotalk.canal.opciones.page';
import PELFiltrarPage from './modules/pel/pages/PELFiltrarPage';
import PELSeleccionarPage from './modules/pel/pages/PELSeleccionarPage';
import GioDrivePage from './modules/giodrive/pages/giodrive.page';
import GiotalkChatMostrarPage from './modules/giotalk/pages/giotalk.chat.mostrar.page';
import GiotalkChatCreadorPage from './modules/giotalk/pages/giotalk.chat.creador.page';
import GiotalkChatParticipantesPage from './modules/giotalk/pages/giotalk.chat.participantes.page';
import LogoutPage from './modules/auth/pages/logout.page';
import PresupuestoRapidoCreadorPage from './modules/encargos/pages/presupuestoRapido/presupuestoRapido.creador.page';
import PresupuestoRapidoPELPage from './modules/encargos/pages/presupuestoRapido/presupuestoRapido.seleccionarLente.page';
import PresupuestoRapidoFittingBoxPage from './modules/encargos/pages/presupuestoRapido/presupuestoRapido.fittinbox.page';
import ArticulosBuscadorPage from './modules/articulos/pages/articulos.buscador.page';
import EncargosCrearPage from './modules/encargos/pages/crearEncargo/encargos.crear.page';
import EncargosCrearPELPage from './modules/encargos/pages/crearEncargo/encargos.seleccionarLente.crear.page';
import EncargosCrearSeleccionarArticuloPage from './modules/encargos/pages/crearEncargo/encargos.seleccionarArticulo.crear.page';
import EncargosCrearFittingbox from './modules/encargos/pages/crearEncargo/encargos.fittingbox.crear.page';
import ReposicionesPage from './modules/newCo/pages/ReposicionesPage';
import factura from './modules/facturas/pages/factura.crear.page';
import EncargosCrearSeleccionarPacientePage from './modules/encargos/pages/crearEncargo/encargos.seleccionarPaciente.crear.page';
import NewClient from './modules/pacientes/pages/newPatient/newPatient';
import ClientList from './modules/pacientes/pages/patientList/patientList';
import ClientFile from './modules/pacientes/pages/patientFile/patientFile';
import GDPR from './modules/pacientes/pages/gdpr/gdpr';
import SignGDPR from './modules/pacientes/pages/signGDPR/signGDPR';
import EyeChart from './modules/pacientes/pages/eyeChart/eyeChart';
import Error from './modules/pacientes/components/error/error';
import nuevoCatalogo from './modules/catalogo/pages/nuevo.catalogo.page';
import PedidoslcList from './modules/pedidos/pages/pedidoslc/pedidolcsList';

// Pacientes Routes
import {
  ROUTE_PACIENTES_EDIT,
  ROUTE_PACIENTES_WATCH,
  ROUTE_PACIENTES_FILE,
  ROUTE_PACIENTES_GDPR,
  ROUTE_PACIENTES_GDPR_SIGN,
  ROUTE_PACIENTES_LIST,
  ROUTE_PACIENTES_NEW,
  ROUTE_PACIENTES_EYECHART_NEW,
  ROUTE_PACIENTES_EYECHART_EDIT,
  ROUTE_PACIENTES_EYECHART_WATCH,
  ROUTE_PACIENTES_ERROR,
  ROUTE_PACIENTES_CONTACTOLOGY_NEW, ROUTE_PACIENTES_CONTACTOLOGY_WATCH, ROUTE_PACIENTES_CONTACTOLOGY_EDIT,
} from './routes.constants';
import { FichaContactologica } from './modules/pacientes/fichaContactologica/fichaContactologica.crear.page';
import RecoverPage from './modules/auth/pages/recover.page';
import { LEFT_SIDEBAR_WIDTH_AND_MARGIN, MIN_WIDTH } from './state/actions/constants/app.constants';

export const AnonymousRouter = ({ history }) => (
  <HashRouter history={history}>
    <MessageReceiver />
    <SystemMessenger />
    <Switch>
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/login/recuperar" component={RecoverPage} />
      <Route exact path="/sso/:ssotoken" component={SsoPage} />
      <Redirect to="/login" />
    </Switch>
  </HashRouter>
);

export const AuthenticatedRouter = ({
  history, sidebar, header, inIframe, loadingCore,
}) => (
  <HashRouter history={history}>
    <MessageReceiver />
    <SystemMessenger />
    <ShowIf condition={false}>
      <div>
        <Alert message="No hay usuario conectado" type="error" />
      </div>
    </ShowIf>
    <ShowIf condition={!loadingCore}>
      <Layout style={{ height: '100%' }} id="main-layout">
        {sidebar}
        <Layout style={{ minWidth: MIN_WIDTH }}>
          {header}
          <Box id="scrollableDiv" style={{ height: '100%', overflowX: 'hidden' }}>
            <Switch>
              <Route exact path="/" component={inIframe ? null : MainPage} />
              <Route exact path={ROUTE_PACIENTES_ERROR} component={Error} />
              <Route exact path={ROUTE_PACIENTES_NEW} component={NewClient} />
              <Route exact path={ROUTE_PACIENTES_LIST} component={ClientList} />
              <Route exact path={ROUTE_PACIENTES_EDIT} component={() => <NewClient create={false} />} />
              <Route exact path={ROUTE_PACIENTES_WATCH} component={() => <NewClient create={false} watch />} />
              <Route exact path={ROUTE_PACIENTES_FILE} component={ClientFile} />
              <Route exact path={ROUTE_PACIENTES_GDPR} component={GDPR} />
              <Route exact path={ROUTE_PACIENTES_GDPR_SIGN} component={SignGDPR} />
              <Route exact path={ROUTE_PACIENTES_EYECHART_NEW} component={EyeChart} />
              <Route exact path={ROUTE_PACIENTES_EYECHART_WATCH} component={() => <EyeChart create={false} watch />} />
              <Route exact path={ROUTE_PACIENTES_EYECHART_EDIT} component={() => <EyeChart create={false} />} />
              <Route exact path={ROUTE_PACIENTES_CONTACTOLOGY_NEW} component={() => <FichaContactologica create watch={false} />} />
              <Route exact path={ROUTE_PACIENTES_CONTACTOLOGY_WATCH} component={() => <FichaContactologica create={false} watch />} />
              <Route exact path={ROUTE_PACIENTES_CONTACTOLOGY_EDIT} component={() => <FichaContactologica create={false} watch={false} />} />
              <Route exact path="/logout" component={LogoutPage} />
              <Route exact path="/encargos/:encargoId/tienda/:tiendaId/mostrar" component={EncargosMostrar} />
              <Route exact path="/presupuestorapido" component={PresupuestoRapidoCreadorPage} />
              <Route exact path="/presupuestorapido/fittinbox" component={PresupuestoRapidoFittingBoxPage} />
              <Route exact path="/presupuestorapido/pel" component={PresupuestoRapidoPELPage} />
              <Route exact path="/talk" component={GIOTalkPage} />
              <Route exact path="/talk/notificaciones" component={NotificacionesGIOTalk} />
              <Route exact path="/talk/notificaciones/opciones" component={GIOTalkOpcionesPage} />
              <Route exact path="/talk/chats/crear" component={GiotalkChatCreadorPage} />
              <Route exact path="/talk/chats/:chatId/mostrar" component={GiotalkChatMostrarPage} />
              <Route exact path="/talk/chats/:chatId/participantes" component={GiotalkChatParticipantesPage} />
              <Route exact path="/talk/chats/:chatId/editarMiembros" component={GiotalkChatCreadorPage} />
              <Route exact path="/drive/:entidadTipoId/carpeta/:entidadId/mostrar" component={GioDrivePage} />
              <Route exact path="/drive/:entidadTipoId/carpeta/:entidadId/tienda/:tiendaId/mostrar" component={GioDrivePage} />
              <Route exact path="/gw1/pel/filtrar" component={PELFiltrarPage} />
              <Route exact path="/gw1/pel/seleccionar" component={PELSeleccionarPage} />
              <Route exact path="/gw1/articulos/buscar" component={ArticulosBuscadorPage} />
              <Route exact path="/gw1/token/invalido" component={TokenNoValido} />
              <Route exact path="/gw1/token/invalido" component={TokenNoValido} />
              <Route exact path="/encargos/(promocion)?/:promocionId?/crear" component={EncargosCrearPage} />
              <Route exact path="/encargos/(promocion)?/:promocionId?/encargo/:encargoUUID/seleccionarLente/linea/:linea" component={EncargosCrearPELPage} />
              <Route exact path="/encargos/(promocion)?/:promocionId?/encargo/:encargoUUID/seleccionarGafa/(tipo)?/:cdgtipo?/linea/:linea" component={props => (<EncargosCrearSeleccionarArticuloPage {...props} modoSeleccionGafa />)} />
              <Route exact path="/encargos/(promocion)?/:promocionId?/encargo/:encargoUUID/seleccionarArticulo/(tipo)?/:cdgtipo?/linea/:linea" component={EncargosCrearSeleccionarArticuloPage} />
              <Route exact path="/encargos/(promocion)?/:promocionId?/encargo/:encargoUUID/seleccionarPaciente" component={EncargosCrearSeleccionarPacientePage} />
              <Route exact path="/encargos/fittingBox/tipo/:cdgtipo/encargo/:encargoUUID/linea/:linea/seleccion/:seleccion" component={EncargosCrearFittingbox} />
              <Route exact path="/reposiciones/mostrar" component={ReposicionesPage} />
              <Route exact path="/gw1/catalogosPropios" component={nuevoCatalogo} />
              <Route exact path="/catalogosPropios" component={nuevoCatalogo} />
              <Route exact path="/factura" component={factura} />
              <Route exact path="/pedidos/pedidoslc" component={PedidoslcList} />

              <Redirect to="/" />
            </Switch>
          </Box>
        </Layout>
      </Layout>
    </ShowIf>
  </HashRouter>
);

AuthenticatedRouter.propTypes = {
  header: PropTypes.any,
  history: PropTypes.any.isRequired,
  sidebar: PropTypes.any,
  inIframe: PropTypes.bool,
};

AuthenticatedRouter.defaultProps = {
  header: null,
  sidebar: null,
  inIframe: false,
};
